import { parseUrl } from 'query-string';

import { Log } from './Log';

let refFromQuery = '';
let refFromHeader = '';
let refType = '';

if (!IS_SSR) {
	try {
		// eslint-disable-next-line @typescript-eslint/camelcase
		const { from, from_type } = parseUrl(window.location.search).query;

		refFromQuery = window.sessionStorage.refFromQuery || from || '';
		// eslint-disable-next-line @typescript-eslint/camelcase
		refType = window.sessionStorage.refType || from_type || '';
	} catch (err) {
		Log.error('Failed parse referer from query string: ', err);
	}

	try {
		if (window.sessionStorage.refFromHeader) {
			refFromHeader = window.sessionStorage.refFromHeader;
		} else if (document.referrer) {
			const matched = document.referrer.match(/(^https?:\/\/)?([^/]+)/);

			if (document.referrer.includes('android-app')) {
				refFromHeader = document.referrer;
			} else if (matched && matched[2]) {
				refFromHeader = matched[2]
					.split('.')
					.slice(-2)
					.join('.');
			}
		}
	} catch (err) {
		Log.error('Failed parse document.referrer: ', err);
	}

	try {
		window.sessionStorage.refFromQuery = refFromQuery;
		window.sessionStorage.refFromHeader = refFromHeader;
		window.sessionStorage.refType = refType;
	} catch (err) {
		Log.error('Failed write referer to sessionStorage: ', err);
	}
}

export const getReferer = () => {
	return refFromQuery || refFromHeader || '';
};

export const getRefererType = () => {
	return refType || '';
};